export const SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight', NONE: 'none' };
export const SWIPE_CLASS = {
	LEFT: 'swiped-row-left',
	RIGHT: 'swiped-row-right'
};
export const SIDE = { BUY: 'buy', SELL: 'sell' };
export const ORDER_ACTION = { EDIT: 'Edit', DELETE: 'Delete' };

export enum SwipeState {
	None = 1,
	Left = 2,
	Right = 3
}

export const SWIPE_OPEN_DELAY = 0;
export const SWIPE_CLOSE_DELAY = 0;

export interface ISwipeable {
	swipeSideClass?: string;
	swipeState?: SwipeState;
}

export class Swipeable implements ISwipeable {
	constructor(swipeSide: string, state: SwipeState) {
		this.swipeSideClass = swipeSide;
		this.swipeState = state;
	}
	private stateSideDictionary = new Map([
		[
			SwipeState.None,
			() => {
				this.reset();
			}
		],
		[
			SwipeState.Left,
			() => {
				this.swipedLeft();
			}
		],
		[
			SwipeState.Right,
			() => {
				this.swipedRight();
			}
		]
	]);

	private swipedLeft() {
		this.changeSideClass('d-none', '');
	}
	private swipedRight() {
		this.changeSideClass('', 'd-none');
	}
	private reset() {
		this.changeSideClass('d-none', 'd-none');
	}

	private changeSideClass(left, right) {
		this.leftSide = '';
		this.rightSide = '';
		setTimeout(() => {
			this.leftSide = left;
			this.rightSide = right;
		}, 250);
	}
	changeSide(action: string) {
		let swipeItemState = { ...SWIPE_RESET };
		switch (action) {
			case SWIPE_ACTION.RIGHT:
				if (this.swipeSideClass !== SWIPE_CLASS.LEFT) swipeItemState = { ...SWIPE_RIGHT };
				break;
			case SWIPE_ACTION.LEFT:
				if (this.swipeSideClass !== SWIPE_CLASS.RIGHT) swipeItemState = { ...SWIPE_LEFT };
				break;
		}

		this.swipeSideClass = swipeItemState.swipeSideClass;
		this.swipeState = swipeItemState.swipeState;
		this.stateSideDictionary.get(this.swipeState)();
	}
	leftSide = 'd-none';
	rightSide = 'd-none';

	swipeSideClass: string;
	swipeState: SwipeState = SwipeState.None;
}

export const SWIPE_RIGHT = { swipeSideClass: SWIPE_CLASS.RIGHT, swipeState: SwipeState.Right };
export const SWIPE_LEFT = { swipeSideClass: SWIPE_CLASS.LEFT, swipeState: SwipeState.Left };
export const SWIPE_RESET = { swipeSideClass: '', swipeState: SwipeState.None };
